/* eslint-disable max-len,no-unused-vars */
import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import './style.scss';
import TickLeaf from '../../images/stickers/tick-leaf.svg';
import TickMagnifying from '../../images/stickers/tick-magnifying.svg';
import TickScience from '../../images/stickers/tick-science.svg';


const HomeIntro = () => {
    const [isVisible, setIsVisible] = React.useState(false);

    return (

        <VisibilitySensor
            delayedCall
            partialVisibility
            active={!isVisible}
            onChange={visible => !isVisible && setIsVisible(visible)}
        >
            <div className="home-intro is-theme-info">
                <div className="home-intro__content">
                    <div className="container home-intro__items">
                        <div className="container home-intro__item">
                            <img
                                src={TickMagnifying}
                                alt="Transparency"
                                className={isVisible && 'slide-in-left'}
                            />
                            <HomeIntroText
                                title="Transparency"
                                body="We batch test every product and keep lab reports available for consumers to see here on our website."
                                isVisible={isVisible}
                            >
                                <Link to="certificates" className="button is-white">
                                View Certificates
                                </Link>
                            </HomeIntroText>
                        </div>
                        <div className="container home-intro__item">
                            <img
                                src={TickLeaf}
                                alt="Trust"
                                className={isVisible && 'slide-in-left'}
                            />

                            <HomeIntroText
                                title="Trust"
                                body="You can trust DR WATSON products to be high quality and consistent. We only source from certified suppliers, and all our products are manufactured and tested to pharmacy standards."
                                isVisible={isVisible}
                            />
                        </div>
                        <div className="container home-intro__item">
                            <img
                                src={TickScience}
                                alt="Traceability"
                                className={isVisible && 'slide-in-left'}
                            />

                            <HomeIntroText
                                title="Traceability"
                                body="We know what’s in all of our products, where the ingredients come from, and how they made. We trace our CBD from seed to shelf."
                                isVisible={isVisible}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </VisibilitySensor>
    );
};

const HomeIntroText = ({
    title, body, children, isVisible,
}) => (
    <div className={`home-intro__item__text ${isVisible ? 'slide-in-right' : ''}`}>
        <div className="title is-size-3-desktop is-size-4-mobile is-spaced">
            {title}
        </div>
        <div className="subtitle is-size-4-desktop is-size-5-mobile">
            {body}
        </div>
        <div className="extra">
            {children && children}
        </div>
    </div>
);
HomeIntroText.defaultProps = {
    children: null,
};
HomeIntroText.propTypes = {
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    isVisible: PropTypes.bool.isRequired,
    children: PropTypes.node,
};


export default HomeIntro;
